const { createContext } = require("react");

const ProfileEditContext = createContext({});

export default ProfileEditContext;
